
// Hip Conditions
const trochanteric_bursitis = 
{
  "name": "Trochanteric Bursitis",
  "meta": {
    links: [
      { label: "Trochanteric Bursitis", url: "https://www.myorthopedicproblem.com/services/trochanteric-bursitis" }
    ]
  },
  "conditions": {
    "pain_description": "chronic",
    "weightbearing_instability": "moderate,severe",
    "rom": "painful_or_unable",
    "popping_snapping_catching": "no",
    "grinding": "no",
    "sleeping_issues": "no",
    "pain_increasing": "yes",
    "pain_location": "side",
    "regular_steroids": "no",
    "swelling": "none"
  }
}

const avascular_newcrosis = 
{
  "name": "Avascular Newcrosis",
  "meta": {},
  "conditions": {
    "age": "35 or younger,36-50",
    "hip_replacement": "no",
    "pain_description": "chronic",
    "weightbearing_instability": "moderate,severe",
    "rom": "painful_or_unable",
    "popping_snapping_catching": "no",
    "grinding": "no",
    "sleeping_issues": "no",
    "pain_increasing": "yes",
    "pain_location": "side",
    "regular_alcohol": "yes",
    "regular_steroids": "yes"
  }
}

const total_hip_dislocation = 
{
  "name": "Total Hip Dislocation",
  "meta": {
    links: [
      { label: "Hip Dislocation", url: "https://www.myorthopedicproblem.com/services/hip-dislocation" }
    ]
  },
  "conditions": {
    "age": "36-50,51-65,66-80,81 or older",
    "pain_description": "acute",
    "cause": "sports_injury",
    "weightbearing_instability": "severe",
    "rom": "painful_or_unable",
    "popping_snapping_catching": "no",
    "grinding": "yes",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "hip_replacement": "yes",
    "stairs_trouble": "yes",
    "pain_location": "front",
    "swelling": "none"
  }
}

const total_hip_replacement = 
{
  "name": "Total Hip Replacement",
  "meta": {
    links: [
      { label: "Total Hip Arthroplasty", url: "https://www.myorthopedicproblem.com/services/totalhiparthroplasty" }
    ]
  },
  "conditions": {
    "age": "36-50,51-65,66-80,81 or older",
    "pain_description": "acute",
    "swelling": "none",
    "weightbearing_instability": "none,moderate",
    "rom": "painful_or_unable",
    "grinding": "no",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "hip_replacement": "yes",
    "stairs_trouble": "yes",
    "pain_location": "front"
  }
}

const natural_hip_dislocation = 
{
  "name": "Natural Hip Dislocation",
  "meta": {
    links: [
      { label: "Hip Dislocation", url: "https://www.myorthopedicproblem.com/services/hip-dislocation" }
    ]
  },
  "conditions": {
    "age": "35 or younger,36-50",
    "pain_description": "acute",
    "cause": "sports_injury",
    "swelling": "none,moderate,severe",
    "weightbearing_instability": "3",
    "rom": "painful_or_unable",
    "grinding": "no",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "hip_replacement": "no",
    "stairs_trouble": "yes",
    "pain_location": "front"
  }
}

const gluteus_medius_tear = 
{
  "name": "Gluteus Medius Tear",
  "meta": {
    links: [
      { label: "Gluteus Medius Tear", url: "https://www.myorthopedicproblem.com/services/gluteus-medius-tear" }
    ]
  },
  "conditions": {
    "pain_description": "chronic",
    "swelling": "1",
    "weightbearing_instability": "none,moderate,severe",
    "rom": "painful_or_unable",
    "grinding": "no",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "hip_replacement": "no",
    "stairs_trouble": "yes",
    "pain_location": "side"
  }
}

const labrum_tear = 
{
  "name": "Labrum Tear",
  "meta": {
    links: [
      { label: "Labrum Tear", url: "https://www.myorthopedicproblem.com/services/labrumtear" }
    ]
  },
  "conditions": {
    "age": "35 or younger,36-50",
    "pain_description": "acute",
    "swelling": "none",
    "weightbearing_instability": "moderate,severe",
    "rom": "painful_or_unable",
    "popping_snapping_catching": "yes",
    "pain_increasing": "yes",
    "hip_replacement": "no",
    "pain_location": "front",
    "regular_steroids": "no"
  }
}

const hip_fracture = 
{
  "name": "Hip Fracture",
  "meta": {
    links: [
      { label: "Hip Fracture", url: "https://www.myorthopedicproblem.com/services/hipfracture" }
    ]
  },
  "conditions": {
    "age": "51-65,66-80,81 or older",
    "pain_description": "acute",
    "cause": "sports_injury",
    "swelling": "none,moderate",
    "weightbearing_instability": "moderate,severe",
    "rom": "painful_or_unable",
    "popping_snapping_catching": "yes",
    "pain_increasing": "yes",
    "stairs_trouble": "yes",
    "pain_location": "front"
  }
}

const hip_djd = 
{
  "name": "Hip Degenerative Joint Disease (DJD)",
  "meta": {
    links: [
      { label: "Arthritis of the Hip", url: "https://www.myorthopedicproblem.com/services/arthritis-of-the-hip" }
    ]
  },
  "conditions": {
    "age": "51-65,66-80,81 or older",
    "pain_description": "chronic",
    "cause": "arthritis_tendonitis",
    "swelling": "none",
    "weightbearing_instability": "none,moderate",
    "rom": "painful_or_unable",
    "popping_snapping_catching": "no",
    "grinding": "yes",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "hip_replacement": "no",
    "stairs_trouble": "yes",
    "pain_location": "front"
  }
}

module.exports = { 
  trochanteric_bursitis, 
  // avascular_newcrosis, 
  total_hip_dislocation, 
  total_hip_replacement, 
  natural_hip_dislocation,
  gluteus_medius_tear,
  labrum_tear,
  hip_fracture,
  hip_djd
}